import { apiRequest } from 'js-api-client';

/**
 * createSeatRequest function.
 * POST to /v2/seat_request to issue a "Negativa de Concessão de Benefício".
 *
 * @param {object} payload - Body to send to the endpoint.
 * @param {string} payload.passenger_name - Beneficiary full name.
 * @param {string} payload.document - Beneficiary CPF (11 digits).
 * @param {string} payload.email - Beneficiary email address.
 * @param {string} payload.birth_date - Beneficiary birth date (YYYY-MM-DD).
 * @param {string} payload.origin_id - Search origin id.
 * @param {string} payload.destination_id - Search destination id.
 * @param {string} payload.trip_date - Selected travel date (YYYY-MM-DD).
 * @returns {Promise<object>} The API response.
 */
const createSeatRequest = (payload) => apiRequest.post('seat_request', payload);

export default createSeatRequest;
